const nav_bar = {
	overview: "Übersicht",
};

export default nav_bar;
